/**
 * APIs returned date string is in utc time but
 * it is not formatted correctly for ISO 8601 format
 * and when passed into new Date(), craeted Date object
 * returns the wrong dateTime. This function fixes this
 * specific issue by adding 'Z' time zone designator as specified in:
 * https://www.w3.org/TR/NOTE-datetime
 *
 * @param {String} dateString
 */
export default function addUTCTimeZoneDesignator (dateString = '') {
  if (!dateString || typeof dateString !== 'string') { return; }

  if (dateString.toLowerCase().indexOf('z') !== -1) {
    return dateString;
  }

  return `${dateString}Z`;
}
